import type { TireSeason } from '../types';
import { cn, TIRE_SEASONS } from '../utils/helpers';
import { t } from '../i18n';

const WHEELS = [
  { x: 6, y: 34 },
  { x: 100, y: 34 },
  { x: 6, y: 130 },
  { x: 100, y: 130 },
];

/** Car seen from above; the wheels show the mounted tire season by colour and letter. Front is at the top. */
export function CarTireDiagram({ season, className }: { season: TireSeason | null; className?: string }) {
  const info = season ? TIRE_SEASONS[season] : null;
  const label = info ? t('Pneumatiky: {label}', { label: info.label.toLowerCase() }) : t('Pneumatiky nezadané');
  return (
    <svg viewBox="0 0 124 200" role="img" aria-label={label} className={cn('h-auto w-full', className)}>
      <title>{label}</title>
      {/* Body */}
      <rect x={22} y={10} width={80} height={180} rx={30} className="fill-secondary-100 stroke-secondary-400" strokeWidth={2} />
      {/* Windshield, roof and rear window */}
      <path d="M34 62 Q62 50 90 62 L86 80 Q62 72 38 80 Z" className="fill-secondary-300" />
      <rect x={38} y={84} width={48} height={50} rx={8} className="fill-secondary-200" />
      <path d="M38 140 Q62 146 86 140 L89 154 Q62 162 35 154 Z" className="fill-secondary-300" />
      {/* Headlights mark the front */}
      <rect x={30} y={16} width={14} height={5} rx={2} className="fill-amber-300" />
      <rect x={80} y={16} width={14} height={5} rx={2} className="fill-amber-300" />
      {WHEELS.map(({ x, y }) => (
        <g key={`${x}-${y}`}>
          <rect x={x} y={y} width={18} height={36} rx={5} fill={info?.color ?? '#cbd5e1'} />
          <text x={x + 9} y={y + 22} textAnchor="middle" fontSize={13} fontWeight={700} fill="#fff" aria-hidden="true">
            {info?.mark ?? '?'}
          </text>
        </g>
      ))}
    </svg>
  );
}
